var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAim = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M36.25 18.375h-3.362c-.738-5.87-5.393-10.525-11.263-11.263V3.75h-3.25v3.362C12.507 7.85 7.85 12.505 7.112 18.375H3.75v3.25h3.362c.738 5.87 5.393 10.527 11.263 11.263v3.362h3.25v-3.362c5.87-.738 10.525-5.393 11.263-11.263h3.362v-3.25zM20 29.75c-5.377 0-9.75-4.375-9.75-9.75 0-5.376 4.373-9.75 9.75-9.75s9.75 4.374 9.75 9.75c0 5.375-4.373 9.75-9.75 9.75zM24.875 20a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0z",
  clipRule: "evenodd"
})));
export default SvgAim;